// Solo la compilación de ensayo activa esta barrera. No acepta otro host/puerto.
export function assertC6Endpoint(value, origin) {
    if (!origin) return;
    if (origin !== 'http://127.0.0.1:8032') throw Error('El destino aislado de C6 no es válido.');
    const url=new URL(String(value),globalThis.location?.href||origin);
    if (url.origin !== origin) throw Error('C6 bloqueó una conexión fuera del servidor aislado.');
}
export function installC6NetworkGuard(origin) {
    if (!origin) return;
    assertC6Endpoint(origin,origin);
    const originalFetch=globalThis.fetch.bind(globalThis);
    globalThis.fetch=(input,...args)=>{
        const value=typeof input==='string'||input instanceof URL?input:input.url;
        const url=new URL(String(value),location.href);
        if(url.origin!==location.origin&&!['blob:','data:'].includes(url.protocol))assertC6Endpoint(url,origin);
        return originalFetch(input,...args);
    };
    const originalOpen=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(method,value,...args){assertC6Endpoint(value,origin);return originalOpen.call(this,method,value,...args);};
    if(globalThis.WebSocket){const Original=globalThis.WebSocket;globalThis.WebSocket=class extends Original{constructor(value,...args){assertC6Endpoint(value,origin);super(value,...args);}};}
}
